import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  CircularProgress,
  Typography,
} from "@mui/material";
import { compactTextFieldSX } from "../common/commonStyle";

const EditCustomerModal = ({
  customer,
  updatedDetails,
  setUpdatedDetails,
  handleFormSubmit,
  handleCloseModal,
  isLoading,
}) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUpdatedDetails({
      ...updatedDetails,
      [name]: value,
    });
  };

  return (
    <Dialog
      open={true}
      onClose={handleCloseModal}
      maxWidth="md"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          left: 40,
        },
      }}
    >
      <DialogTitle sx={{ fontSize: "1rem" }}>Edit Customer</DialogTitle>
      <DialogContent>
        <form onSubmit={handleFormSubmit}>
          <Grid container spacing={3}>
            {/* Left Column - 5 Fields */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Username"
                value={updatedDetails.username}
                // onChange={handleInputChange}
                name="username"
                variant="outlined"
                margin="normal"
                size="small"
                sx={{ ...compactTextFieldSX, "& .MuiOutlinedInput-root": { backgroundColor: "#fff" } }}
                InputLabelProps={{ sx: { fontSize: "0.7rem" } }}
                inputProps={{ style: { fontSize: "0.7rem" } }}
              />
              <TextField
                fullWidth
                label="Customer Name"
                value={updatedDetails.customer_name}
                onChange={handleInputChange}
                name="customer_name"
                variant="outlined"
                margin="normal"
                size="small"
                sx={{ "& .MuiOutlinedInput-root": { backgroundColor: "#fff" } }}
                InputLabelProps={{ sx: { fontSize: "0.7rem" } }}
                inputProps={{ style: { fontSize: "0.7rem" } }}
              />
              <TextField
                fullWidth
                label="Customer Email"
                value={updatedDetails.customer_email}
                onChange={handleInputChange}
                name="customer_email"
                variant="outlined"
                margin="normal"
                // disabled
                size="small"
                sx={{ "& .MuiOutlinedInput-root": { backgroundColor: "#fff" } }}
                InputLabelProps={{ sx: { fontSize: "0.7rem" } }}
                inputProps={{ style: { fontSize: "0.7rem" } }}
              />
              <TextField
                fullWidth
                label="Customer Mobile"
                value={updatedDetails.customer_mobile}
                onChange={handleInputChange}
                name="customer_mobile"
                variant="outlined"
                margin="normal"
                // disabled
                size="small"
                sx={{ "& .MuiOutlinedInput-root": { backgroundColor: "#fff" } }}
                InputLabelProps={{ sx: { fontSize: "0.7rem" } }}
                inputProps={{ style: { fontSize: "0.7rem" } }}
              />
              <TextField
                fullWidth
                label="Customer Address 1"
                value={updatedDetails.customer_add1}
                onChange={handleInputChange}
                name="customer_add1"
                variant="outlined"
                margin="normal"
                size="small"
                sx={{ "& .MuiOutlinedInput-root": { backgroundColor: "#fff" } }}
                InputLabelProps={{ sx: { fontSize: "0.7rem" } }}
                inputProps={{ style: { fontSize: "0.7rem" } }}
              />
            </Grid>

            {/* Right Column - 4 Fields */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Customer Address 2"
                value={updatedDetails.customer_add2}
                onChange={handleInputChange}
                name="customer_add2"
                variant="outlined"
                margin="normal"
                size="small"
                sx={{ "& .MuiOutlinedInput-root": { backgroundColor: "#fff" } }}
                InputLabelProps={{ sx: { fontSize: "0.7rem" } }}
                inputProps={{ style: { fontSize: "0.7rem" } }}
              />
              <TextField
                fullWidth
                label="City"
                value={updatedDetails.city}
                onChange={handleInputChange}
                name="city"
                variant="outlined"
                margin="normal"
                size="small"
                sx={{ "& .MuiOutlinedInput-root": { backgroundColor: "#fff" } }}
                InputLabelProps={{ sx: { fontSize: "0.7rem" } }}
                inputProps={{ style: { fontSize: "0.7rem" } }}
              />
              <TextField
                fullWidth
                label="State"
                value={updatedDetails.state}
                onChange={handleInputChange}
                name="state"
                variant="outlined"
                margin="normal"
                size="small"
                sx={{ "& .MuiOutlinedInput-root": { backgroundColor: "#fff" } }}
                InputLabelProps={{ sx: { fontSize: "0.7rem" } }}
                inputProps={{ style: { fontSize: "0.7rem" } }}
              />
              <TextField
                fullWidth
                label="pin Code"
                value={updatedDetails.pin}
                onChange={handleInputChange}
                name="pin"
                variant="outlined"
                margin="normal"
                size="small"
                sx={{ "& .MuiOutlinedInput-root": { backgroundColor: "#fff" } }}
                InputLabelProps={{ sx: { fontSize: "0.7rem" } }}
                inputProps={{ style: { fontSize: "0.7rem" } }}
              />
            </Grid>
          </Grid>

          {/* Active Checkbox */}
          <FormControlLabel
            control={
              <Checkbox
                checked={updatedDetails.is_active}
                onChange={(e) =>
                  setUpdatedDetails({
                    ...updatedDetails,
                    is_active: e.target.checked,
                  })
                }
                name="is_active"
                color="primary"
              />
            }
            label="Active"
          />

          {/* Actions */}
          <DialogActions>
            <Button
              onClick={handleCloseModal}
              color="primary"
              sx={{ fontSize: "0.7rem" }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              disabled={isLoading}
              sx={{ fontSize: "0.7rem" }}
            >
              {isLoading ? <CircularProgress size={24} /> : "Save Changes"}
            </Button>
          </DialogActions>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default EditCustomerModal;
